import { FirebaseApp, getApp, getApps, initializeApp } from 'firebase/app';
import { getRemoteConfig, fetchAndActivate } from 'firebase/remote-config';

import { AppSlugEnum } from '../types/whiteLabel';

const appsToReset: Set<string> = new Set();

const getFirebaseConfigBySlug = (appSlug: string) => {
  switch (appSlug) {
    case AppSlugEnum.SQUAMISH:
      return process.env.REACT_APP_SQUAMISH_FIREBASE_CONFIG;
    case AppSlugEnum.TLAAMING:
      return process.env.REACT_APP_TLAAMIN_FIREBASE_CONFIG;
    case AppSlugEnum.SQEWLETS:
      return process.env.REACT_APP_SQEWLETS_FIREBASE_CONFIG;
    case AppSlugEnum.STZUMINUS:
      return process.env.REACT_APP_STZUMINUS_FIREBASE_CONFIG;
    case AppSlugEnum.TSOWTUNLELUM:
      return process.env.REACT_APP_TSOWTUNLELUM_FIREBASE_CONFIG;
    case AppSlugEnum.QUALICUM:
      return process.env.REACT_APP_QUALICUM_FIREBASE_CONFIG;
    case AppSlugEnum.COWICHAN:
      return process.env.REACT_APP_COWICHAN_FIREBASE_CONFIG;
    case AppSlugEnum.KWAKIUTL:
      return process.env.REACT_APP_KWAKIUTL_FIREBASE_CONFIG;
    case AppSlugEnum.CHIYAQTEL:
      return process.env.REACT_APP_CHIYAQTEL_FIREBASE_CONFIG;
    case AppSlugEnum.LIGILDAX:
      return process.env.REACT_APP_LIGILDAX_FIREBASE_CONFIG;
    case AppSlugEnum.MUSQUEAM:
      return process.env.REACT_APP_MUSQUEAM_FIREBASE_CONFIG;
    case AppSlugEnum.GWASALA:
      return process.env.REACT_APP_GWASALA_FIREBASE_CONFIG;
    default:
      return process.env.REACT_APP_CHECKINGIN_FIREBASE_CONFIG;
  }
};

export const firebaseService = async (appSlug: string) => {
  const firebaseConfigRaw = getFirebaseConfigBySlug(appSlug);
  if (!firebaseConfigRaw) {
    throw new Error('Firebase config not defined');
  }

  const firebaseConfigParsed = JSON.parse(firebaseConfigRaw);
  const existingApp = getApps().find((a) => a.name === appSlug);

  let app: FirebaseApp;
  if (existingApp) {
    app = getApp(appSlug);
  } else {
    app = initializeApp(firebaseConfigParsed, appSlug);
  }

  const remoteConfig = getRemoteConfig(app);
  const shouldForceRefresh = appsToReset.has(appSlug);

  remoteConfig.settings.minimumFetchIntervalMillis = shouldForceRefresh
    ? 0
    : 3600000;

  if (shouldForceRefresh) {
    await fetchAndActivate(remoteConfig);
    appsToReset.delete(appSlug);
  }

  return { app, remoteConfig };
};

export const resetFirebaseApp = (appSlug: string) => {
  appsToReset.add(appSlug);
};
